import { useEffect } from "react";
import resetAllStores from "../../../../hooks/resetAllStores";
import { useSearchParams, useNavigate } from "react-router-dom";
import { Typography } from "@mui/material"

const ErrorPage = () => {
    let navigate = useNavigate();
    const [searchParams] = useSearchParams();

    useEffect(() => {
        if (searchParams.get("code") === "401") {
            // Authentication error return user to login page
            resetAllStores();
            navigate("/");
        }
    }, [searchParams, navigate])

    return (
        <Typography>There was an error loading the page.</Typography>
    )
}

export default ErrorPage;
